/*
 * `core/browser.js`
 *  -  ブラウザ間の互換性対応
 *
 * 使用方法:
 *  - import { functionName } from "./browser.js";
 */


/**
 * webpのサポートをチェックする関数
 */
export function supportsWebp() {
  const canvas = document.createElement("canvas");
  const webp = canvas.getContext && canvas.getContext("2d")
    ? canvas.toDataURL("image/webp").indexOf("data:image/webp") === 0
    : false;

  if (!webp) {
    document.body.classList.add("no-webp");
  }
}